const DawaColors = {
  black: "#000000",
  blue: "#1C75BC",
  grey: "#C4C4C4",
  white: "#FFFFFF",
  darkGrey: "#333333",
}

export { DawaColors }
